import React, { useEffect, useState } from 'react';
import { useVibrancy } from '../VibrancyDashboardContext';
import { LocationAndStudentData, VibrancyProfileService } from '../vibrancyProfileService';
import { HeaderIcon, cardHeaderStyle, cardStyle } from './shared';

const EMPTY: LocationAndStudentData = {
    location: { indiaCount: 0, abroadCount: 0, indiaPct: 0, abroadPct: 0, totalLocated: 0 },
    studentCoverage: null,
};

const SkeletonTile: React.FC = () => (
    <div className="flex-grow-1 rounded-3 p-3 placeholder-glow" style={{ background: '#f4f6fb' }}>
        <span className="placeholder d-block col-6 mx-auto mb-2" style={{ height: 22 }} />
        <span className="placeholder d-block col-8 mx-auto" style={{ height: 10 }} />
    </div>
);

/** VD-07 — India vs Abroad + Student Data Coverage. */
const LocationAndStudent: React.FC = () => {
    const { selectedInstituteId, instituteLoaded, compareMode } = useVibrancy();

    const [result,  setResult]  = useState<LocationAndStudentData>(EMPTY);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!selectedInstituteId) { setResult(EMPTY); return; }
        setLoading(true);
        VibrancyProfileService.getLocationAndStudent(selectedInstituteId)
            .then(r  => setResult(r.data?.data || EMPTY))
            .catch(() => setResult(EMPTY))
            .finally(() => setLoading(false));
    }, [selectedInstituteId]);

    if (!instituteLoaded) return null;

    const { location: loc } = result;

    return (
        <div className="row g-3 mb-3">
            {/* ── India vs Abroad ─────────────────────────────────────────── */}
            <div className="col-md-12">
                <div className="card h-100" style={cardStyle}>
                    <div className="card-header bg-white d-flex justify-content-between align-items-center" style={cardHeaderStyle}>
                        <div className="fw-medium d-flex align-items-center gap-2 font-14">
                            <HeaderIcon icon="🌍" bg="#cffafe" color="#0891b2" />India vs Abroad
                        </div>
                        <span className="font-13 text-secondary">Current location</span>
                    </div>
                    <div className="card-body">
                        <div className="d-flex gap-2">
                            {loading ? (
                                <><SkeletonTile /><SkeletonTile /></>
                            ) : (
                                <>
                                    <div className="flex-grow-1 rounded-3 p-3 text-center" style={{ background: '#ebf2ff' }}>
                                        <div className="fw-bold" style={{ fontSize: 22, color: '#1b52c4' }}>{loc.indiaPct}%</div>
                                        <div className="text-uppercase fw-bold mt-1" style={{ fontSize: 10, color: '#8fa0c0' }}>India Based</div>
                                        <div className="fw-semibold mt-1" style={{ fontSize: 10, color: '#1b52c4' }}>{loc.indiaCount} alumni</div>
                                    </div>
                                    <div className="flex-grow-1 rounded-3 p-3 text-center" style={{ background: '#cffafe' }}>
                                        <div className="fw-bold" style={{ fontSize: 22, color: '#0891b2' }}>{loc.abroadPct}%</div>
                                        <div className="text-uppercase fw-bold mt-1" style={{ fontSize: 10, color: '#8fa0c0' }}>Abroad</div>
                                        <div className="fw-semibold mt-1" style={{ fontSize: 10, color: '#0891b2' }}>{loc.abroadCount} alumni</div>
                                    </div>
                                </>
                            )}
                        </div>

                        {/* Compare row — shown only when compareMode is ON */}
                        {!loading && compareMode && (
                            <div className="mt-2 d-flex align-items-center gap-2 pt-2 border-top"
                                style={{ borderTopStyle: 'dashed', borderTopColor: '#e1e8f5', fontSize: 10.5 }}>
                                <span className="text-uppercase fw-bold" style={{ color: '#8fa0c0' }}>Prev period abroad:</span>
                                <span className="fw-bold" style={{ color: '#4a5a80' }}>—</span>
                                <span className="fw-semibold" style={{ color: '#8fa0c0' }}>Historical snapshot pending</span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LocationAndStudent;
